import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { DeviceInfoService } from '../../../shared/services/device-info.service';

@Injectable({
  providedIn: 'root',
})
export class SubBillerService {
  constructor(
    private http: HttpClient,
    private deviceInfoService: DeviceInfoService,
  ) {}

  //Monitoring Companies related APIs
  fetchSubBillerList(params?: any) {
    return this.http
      .get('/api/sub_biller/', { params: params })
      .pipe(map((response) => response));
  }
  fetchSubBillerById(id?: any) {
    return this.http
      .get(`/api/sub_biller/${id}/`)
      .pipe(map((response) => response));
  }
  async createSubBiller(requestData?: any, params?: any) {
    const body = {
      ...requestData,
    };
    return lastValueFrom(
      this.http
        .post('/api/sub_biller/', body)
        .pipe(map((response) => response)),
    );
  }
  async updateSubBillerDetailById(id: string, requestData: any, params?: any) {
    const body = {
      ...requestData,
    };
    return lastValueFrom(
      this.http
        .put(`/api/sub_biller/${id}/`, body, {
          params: params,
        })
        .pipe(map((response) => response)),
    );
  }
  async deleteSubBiller(id: any, params?: any) {
    const body = {};
    return lastValueFrom(
      this.http.put(`api/sub_biller/${id}/`, body, {
        params: params,
      }),
    );
  }
}
